import { Title } from '@components';
import { Box, styled } from '@mui/material';
import { colors } from '@themes/colors';
import { breakpoints, palette } from '@themes/theme.helpers';
import { ReactNode } from 'react';
import { A11y, Autoplay, Navigation, Pagination, Parallax } from 'swiper';
import 'swiper/css/bundle';
import { Swiper, SwiperProps } from 'swiper/react';

// STYLES
//--------
const SliderWrapper = styled(Box)<SliderProps>`
  .swiper {
    text-align: center;
  }

  .swiper .hero-block-content {
    height: auto;
  }

  .swiper-button-next,
  .swiper-button-prev {
    color: ${palette.common('white')};
    background-color: ${palette.primary('main')};
    width: 48px;
    height: 48px;
    border-radius: 50%;

    &:after {
      font-size: 14px;
      font-weight: 800;
    }
    ${breakpoints.down('md')} {
      opacity: 0.25;
    }
  }

  .swiper-pagination-bullets {
    position: static;
    top: auto;
    left: auto;
    width: auto;
    margin: 16px auto;
    //padding: 8px;
    background: ${colors.secondary.lightBlue};
    display: inline-block;
    border-radius: 4px;
    padding: 0 !important;
    ${breakpoints.up('md')} {
      //  padding: 10px 20px;
    }
  }

  .swiper-pagination-bullet {
    width: 12px;
    height: 12px;
    opacity: 1;
    background: ${colors.background.white};
    margin: 8px 4px 4px 4px !important;
    ${breakpoints.up('md')} {
      margin: 12px 8px 8px 8px !important;
    }
    &-active {
      background: ${colors.primary.mainGreen};
    }
  }

  .swiper-button-disabled {
    pointer-events: all;
  }

  .block-container {
    padding-left: 0 !important;
    padding-right: 0 !important;
  }
`;

// TYPES
//-------

/**
 * Pass children, title and any SwiperProps
 **/
export type SliderProps = SwiperProps & {
  children?: ReactNode;
  title?: string;
};

// COMPONENTS
//------------

/**
 * Responsive Slider.
 * Use for Slideshow / Slide Carousel.
 * https://swiperjs.com/react
 * https://swiperjs.com/demos
 */
export const Slider = ({ children, title, ...swiperProps }: SliderProps) => {
  return (
    <SliderWrapper className='slider'>
      <Title>{title}</Title>
      <Swiper
        {...swiperProps}
        modules={[Navigation, Pagination, A11y, Autoplay, Parallax]}
        navigation
        pagination={{ clickable: true }}
        observer={true}
        observeSlideChildren={true}
        resizeObserver={true}
      >
        {children}
      </Swiper>
    </SliderWrapper>
  );
};
